<template>
  <div class="head">
    <div class="headlogo">
      <img src="@/assets/images/logo3.png">
    </div>
    <div class="headmtitle"></div>
    <div class="headmenu">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="2" :to="{name:'about'}">关于我们</el-menu-item>
        <el-menu-item index="3">旅游产品</el-menu-item>
        <el-menu-item index="4">旅游问答</el-menu-item>
        <el-menu-item index="5">口碑榜</el-menu-item>
        <el-menu-item index="6">门店网点</el-menu-item>
      </el-menu>
    </div>
    <div class="headmenu_xs">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-submenu index="2">
          <template slot="title"><i class="el-icon-more-outline"></i></template>
          <el-menu-item index="2" :to="{name:'about'}">关于我们</el-menu-item>
          <el-menu-item index="3">旅游产品</el-menu-item>
          <el-menu-item index="4">旅游问答</el-menu-item>
          <el-menu-item index="5">口碑榜</el-menu-item>
          <el-menu-item index="6">门店网点</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headmain',
  data() {
    return {
      activeIndex: "2"
    }
  },
  props: {
  },
  methods: {
    handleSelect(key, keyPath) {
      switch (key) {
        case '1':
          this.$router.push({ name: 'index' });
          break;
        case '2':
          this.$router.push({ name: 'about' });
          break;
        case '4':
          this.$router.push({ name: 'question' });
          break;
        case '6':
          this.$router.push({ name: 'contant' });
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    switch (this.$route.name) {
      case 'index':
        this.activeIndex = "1";
        break;
      case 'about':
        this.activeIndex = "2";
        break;
      case 'question':
        this.activeIndex = "4";
        break;
      case 'ques_view':
        this.activeIndex = "4";
        break;
      case 'contant':
        this.activeIndex = "6";
        break;
      default:
        break;
    }
  },
  watch: {
  }
}
</script>

<style lang="less">
.head {
  width: 100%;
  max-width: 1180px;
  height: 90px;
  margin: 0 auto;
  padding: 0 20px;
  .headlogo {
    float: left;
    width: 150px;
    height: 90px;
    padding: 20px 0;
    img {
      width: 100%;
    }
  }
  .headmtitle {
    display: none;
  }
  .headmenu {
    float: right;
    display: grid;
    width: calc(100% - 500px);
    height: 90px;
    padding: 10px 0 0 0;
    .el-menu.el-menu--horizontal {
      border-bottom: 0;
    }
  }
  .headmenu_xs {
    float: right;
    width: 50px;
    display: none;
    overflow: hidden;
    .el-menu.el-menu--horizontal {
      border-bottom: 0;
    }
    .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      border: 0;
    }
  }
  @media screen and (max-width: 1066px) {
    .headmenu {
      display: none;
    }
    .headmenu_xs {
      display: grid;
    }
  }
}
@media screen and (max-width: 1066px) {
  .head {
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 10px;
    height: 80px;
    .headlogo {
      float: left;
      width: 120px;
      padding: 20px 0;
      img {
        width: 100%;
      }
    }
    .headmtitle {
      display: grid;
      float: left;
      width: 120px;
      height: 80px;
      line-height: 80px;
      margin-left: 20px;
    }
  }
}
</style>
